import { FieldConfig } from '@smartflip/data-models';

export const financialFieldsSettingsConfigs: FieldConfig[] = [
  { name: 'maximumPurchasePrice', type: 'input', label: 'Max Purchase Price' },
  {
    name: 'maximumAfterRepairValue',
    type: 'input',
    label: 'Max After Repair Value',
  },
  {
    name: 'maximumRenovationBudget',
    type: 'input',
    label: 'Max Renovation Budget',
  },
  {
    name: 'maximumLoanToValuePercent',
    type: 'input',
    label: 'Max Loan to Value (%)',
  },
  {
    name: 'minimumProfitMarginPercent',
    type: 'input',
    label: 'Min Profit Margin (%)',
    helperText: 'Used to assess purchase feasibility',
  },
];
